<template>
  <div class="section_fiche_pc_course">
    <h5>Infos PC Course</h5>
    <b-row>
      <b-col>
        <h6>Identité du coureur</h6>
        <p><b>Nom - Prénom</b>: {{ coureur.nom }} {{ coureur.prenom }}</p>
        <p>
          <b>Sexe</b>:
          <span v-if="coureur.sexe == 'M'">Homme</span>
          <span v-else-if="coureur.sexe == 'F'">Femme</span>
          <span v-else>Non renseigné</span>
        </p>
        <p>
          <b>Année de naissance</b>: <span v-if="coureur.naissance_complet && coureur.naissance_complet != ''">{{ coureur.naissance_complet }}</span>
          <span v-else-if="coureur.naissance && coureur.naissance != ''">{{ coureur.naissance }}</span>
          <span v-else>Non renseigné</span>
        </p>

        <p>
          <b>Nationalité</b>: <span v-if="coureur.nation && coureur.nation != ''">{{ coureur.nation }}</span
          ><span v-else>Non renseigné</span>
        </p>
        <p>
          <b>Club</b>: <span v-if="coureur.club && coureur.club != ''">{{ coureur.club }}</span
          ><span v-else>Non renseigné</span>
        </p>
      </b-col>
      <b-col>
        <h6>Informations de contact</h6>
        <p>
          <b>Tel du coureur</b>: <span v-if="coureur.tel && coureur.tel != ''">{{ coureur.tel }}</span
          ><span v-else>Non renseigné</span>
        </p>
        <p>
          <b>Personne à contacter en cas d'urgence</b> : <span v-if="coureur.contact_urgence && coureur.contact_urgence != ''">{{ coureur.contact_urgence }}</span
          ><span v-else>Non renseigné</span>
        </p>
        <p>
          <b>Téléphone à contacter en cas d'urgence</b> : <span v-if="coureur.tel_contact_urgence && coureur.tel_contact_urgence != ''">{{ coureur.tel_contact_urgence }}</span
          ><span v-else>Non renseigné</span>
        </p>
      </b-col>
      <b-col>
        <h6>Statut de course</h6>
        <p v-if="coureur.depart"><b>Départ</b>: {{ coureur.depart }}</p>

        <p>
          <b>Statut</b>: <span v-if="coureur.statut.text && coureur.statut.text != ''">{{ coureur.statut.text }}</span>
        </p>

        <p v-if="coureur.depart && !coureur.statut.arrivee && coureur.estimation">
          <b>Distance parcourue estimée</b>: <span v-if="coureur.estimation.distance != '' && !isNaN(coureur.estimation.distance)">{{ Number(coureur.estimation.distance).toFixed(1) }}km</span>
        </p>
      </b-col>
    </b-row>
    <hr />
    <SectionLocalisationUrgence :coureur="coureur"></SectionLocalisationUrgence>
  </div>
</template>

<script>
import SectionLocalisationUrgence from "./SectionLocalisationUrgence.vue";
export default {
  props: ["coureur"],
  components: {
    SectionLocalisationUrgence,
  },
};
</script>

<style lang="scss" scoped>
</style>